import moment from "moment";

export default function formatDateTime(value = "") {
  if (value) {
    return moment(String(value)).format("DD.MM.YYYY HH:mm");
  }
  return "";
}
